<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header/>
    <Scroll/>

    <div class="hp_loginWrap">
      <h2 class="hp_loginTit">
        로그인
        <p>로그인을 하시면 회원만의 서비스를 이용하실 수 있습니다.</p>
      </h2>

      <div class="hp_loginTabWrap">
        <ul class="hp_loginTab"> <!-- 로그인 탭 -->
          <li :class="{ loginTabOn: statusData.activeTab === 'member' }" @click="setActiveTab('member')">회원 로그인</li>
          <li :class="{ loginTabOn: statusData.activeTab === 'nonMember' }" @click="setActiveTab('nonMember')">비회원 예약조회</li>
        </ul>

        <div v-if="statusData.activeTab === 'member'">
          <ul class="hp_loginInput">
            <li>
              <input
                type = "text"
                id = 'customer_login_ID'
                v-model="formData.customerLoginID"
                maxlength="15"
                placeholder="아이디"
                @keyup.enter="check_form"
              >
              <!-- <p>{{errorData.customerLoginIDError}}</p> -->
            </li>
            <li class="hp_loginInput_password">
              <input
                  type = "password"
                  id = 'customer_password'
                  v-model="formData.customerPassword"
                  maxlength="20"
                  placeholder="비밀번호"
                  @keyup.enter="check_form"
                >
              <!-- <p>{{errorData.customerPasswordError}}</p> -->
            </li>
          </ul>
          <button class="hp_loginBtn" v-on:click="check_form">로그인</button>
          <a href="/join" target="_self" class="hp_loginBtn02">회원가입</a>
          <ul class="hp_loginSearch">
            <li><a href="/Search?activeTab=1">아이디 찾기</a></li>
            <li><a href="/Search?activeTab=2">비밀번호 찾기</a></li>
          </ul>
          <div class="hp_snsLoginBox">
            <div class="hp_snsLogin_tit">
              SNS 간편 로그인
            </div>
            <p class="hp_snsLogin_subTxt">
              SNS계정으로 쉽고 빠르게 로그인을 할 수 있습니다.
            </p>
            <ul class="hp_snsLogin_icon">
              <li>
                 <a
                    :href="kakaoLoginUrl"
                  >
                  <img src="../../../assets/images/icon/login_kakao.png" alt="카카오로그인">
                  <p>카카오톡 로그인</p>
                </a>
              </li>
              <!-- <li>
                <a
                    :href="naverLoginUrl"
                  >
                  <img src="../../../assets/images/icon/login_naver.png" alt="네이버로그인">
                  <p>네이버 로그인</p>
                </a>
              </li> -->
            </ul>
          </div>
        </div> <!-- 회원 로그인 탭 연결 / 여기까지임 -->

        <div v-if="statusData.activeTab === 'nonMember'">
          <ul class="hp_loginInput">
            <li class="hp_loginInput_name"> <!-- 예약자명 작성, ID랑 v-model 바꿔야함 -->
              <input
                type = "text"
                id = 'reservation_customer_name'
                v-model="formData.customerLoginID"
                maxlength="8"
                placeholder="예약자명"
              >
            </li>
            <li class="hp_loginInput_phone"> <!-- 핸드폰 번호 작성, ID랑 v-model 바꿔야함 -->
              <input
                  type = "text"
                  id = 'reservation_customer_phone_number'
                  v-model="formData.reservationCustomerPhoneNumber"
                  maxlength="20"
                  placeholder="핸드폰번호 (- 입력포함)"
                >
            </li>
          </ul>
          <button class="hp_loginBtn" v-on:click="check_form">비회원 예약조회</button>
          <div class="hp_loginNotice">
            ※예약 시 제공한 예약자명과 핸드폰번호를 입력해 주세요.
            <br>
            ※예약정보가 기억나지 않을 경우 고객센터로 문의해 주세요.
          </div>
        </div> <!-- 비회원 예약조회 탭 연결 / 여기까지임 -->
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword
} from '../../ETC/Validation.vue'
import {
  check_login,
  base_homepage_url_export
} from '../../ETC/Axios.vue'

export default {
  name: 'Login',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll,
    Spiner
  },
  setup () {
    return {
      clientId: '09c5eb1e59461c0210d2029fa7e09651',
      redirectUri: `${base_homepage_url_export}KaKaoLogin`,
      formData: ref({
        customerLoginID: '',
        customerPassword: '',
        reservationCustomerName: '',
        reservationCustomerPhoneNumber: ''
      }),
      errorData: ref({
        customerLoginIDError: '',
        customerPasswordError: ''
      }),
      statusData: ref({
        activeTab: 'member',
        customerLoginStatus: false,
        customerPasswordStatus: false,
        spinnerStatus: false,
        isMemberTab: true
      })
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerLoginIDError = '아이디는 필수 입력입니다.'
        this.statusData.customerLoginStatus = false
      } else if (removeWhitespace(value).length < 5) {
        this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
        this.statusData.customerLoginStatus = false
      } else if (validateEngNum(removeWhitespace(value))) {
        this.errorData.customerLoginIDError = ''
        this.statusData.customerLoginStatus = true
      } else {
        this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
        this.statusData.customerLoginStatus = false
      }
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = '비밀번호는 필수 입력입니다.'
        this.statusData.customerPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '최소 8자리 / 숫자, 특수문자 각 1회 이상을 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    },
    'formData.reservationCustomerPhoneNumber': function (value) {
      let cleanValue = value.replace(/\D/g, '')

      if (cleanValue.length <= 3) {
        this.formData.reservationCustomerPhoneNumber = cleanValue
      } else if (cleanValue.length <= 7) {
        this.formData.reservationCustomerPhoneNumber = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3)}`
      } else {
        this.formData.reservationCustomerPhoneNumber = `${cleanValue.slice(0, 3)}-${cleanValue.slice(3, 7)}-${cleanValue.slice(7, 11)}`
      }
    }
  },
  computed: {
    naverLoginUrl () {
      return `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=o2u_tLTBvlSSzZSlXSbn&state=STATE_STRING&redirect_uri=${base_homepage_url_export}NaverLogin`
    },
    kakaoLoginUrl () {
      return `https://kauth.kakao.com/oauth/authorize?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&response_type=code`
    }
  },
  methods: {
    setActiveTab (tab) {
      this.statusData.activeTab = tab
    },
    check_form: function () {
      if (this.statusData.activeTab === 'member') {
        if (
          this.statusData.customerLoginStatus &&
          this.statusData.customerPasswordStatus
        ) {
          this.statusData.spinnerStatus = true
          check_login(
            this.formData.customerLoginID,
            this.formData.customerPassword
          ).then(result => {
            if (result === 1) {
              if (this.$route.query.reser_status) {
                this.$router.push({path: '/Reservation'})
              } else {
                this.$router.push('/')
              }
            } else {
              this.statusData.spinnerStatus = false
              alert('아이디 또는 비밀번호를 확인해주세요.')
            }
          })
        } else {
          alert('ID 및 비밀번호를 확인해주세요.')
        }
      } else if (this.statusData.activeTab === 'nonMember') {
        const myID = 2
        const reservationCustomerName = this.formData.customerLoginID
        const reservationCustomerPhoneNumber = this.formData.reservationCustomerPhoneNumber

        this.$router.push({
          path: '/My',
          query: {
            myID,
            reservation_customer_name: reservationCustomerName,
            reservation_customer_phone_number: reservationCustomerPhoneNumber
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Login/Login.vue